module.exports = __webpack_public_path__ + "media/img/apple-icon-120x120-97bbb5b48ba8fecfd9147897636c818a.png";